import { render, staticRenderFns } from "./V2CourseCardSmall.vue?vue&type=template&id=527c931b&scoped=true&"
import script from "./V2CourseCardSmall.vue?vue&type=script&lang=js&"
export * from "./V2CourseCardSmall.vue?vue&type=script&lang=js&"
import style0 from "./V2CourseCardSmall.vue?vue&type=style&index=0&id=527c931b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527c931b",
  null
  
)

export default component.exports